import "mapbox-gl/dist/mapbox-gl.css";
import * as mapboxgl from "mapbox-gl";

export default class {
  map = null;
  markers = [];

  constructor(divId, centerLatitude, centerLongitude, zoom) {
    mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_TOKEN;
    this.map = new mapboxgl.Map({
      container: divId,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [centerLongitude, centerLatitude],
      zoom: zoom
    });
  }

  addMarker(latitude, longitude, onSelect, color) {
    const markerOptions = {};
    if (null !== color) {
      markerOptions.color = color;
    }
    let marker = new mapboxgl.Marker(markerOptions)
      .setLngLat([longitude, latitude])
      .addTo(this.map);

    marker.setPopup(
      new mapboxgl.Popup().on("open", () => {
        onSelect.call();
        marker.togglePopup();
      })
    );
    this.markers.push(marker);
  }

  removeMarkers() {
    this.markers.forEach(marker => {
      marker.remove();
    });
  }
}
